export const REQUEST_SPECIALIST_STATUS = {
  REQUESTED: 'requested',
  ASSIGNED: 'assigned',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
}

export const REQUEST_SPECIALIST_STATUS_OPTIONS = [
  { value: REQUEST_SPECIALIST_STATUS.REQUESTED, label: 'Solicitado' },
  { value: REQUEST_SPECIALIST_STATUS.ASSIGNED, label: 'Atribuído' },
  { value: REQUEST_SPECIALIST_STATUS.COMPLETED, label: 'Concluído' },
  { value: REQUEST_SPECIALIST_STATUS.CANCELLED, label: 'Cancelado' },
]

export const REQUEST_SPECIALIST_ACTIVE_STATUSES = [
  REQUEST_SPECIALIST_STATUS.REQUESTED,
  REQUEST_SPECIALIST_STATUS.ASSIGNED,
]

export const getRequestSpecialistStatusLabel = status => {
  const option = REQUEST_SPECIALIST_STATUS_OPTIONS.find(item => item.value === status)
  return option ? option.label : '-'
}

export const getRequestSpecialistStatusVariant = status => {
  switch (status) {
    case REQUEST_SPECIALIST_STATUS.REQUESTED:
      return 'warning'
    case REQUEST_SPECIALIST_STATUS.ASSIGNED:
      return 'primary'
    case REQUEST_SPECIALIST_STATUS.COMPLETED:
      return 'success'
    case REQUEST_SPECIALIST_STATUS.CANCELLED:
      return 'secondary'
    default:
      return 'light'
  }
}

export const isRequestSpecialistActive = status => REQUEST_SPECIALIST_ACTIVE_STATUSES.includes(status)
